import Names from './names';
import { isAuth } from '@/services/PermissionService';
import Content from '@/components/layout/Content.vue';
import {
	B2B_COMPANY_BUDGET,
	ACCOUNT_RECORDS,
	B2B_VIEW_COMPANY_DETAILS,
	B2B_VIEW_COMPANY_EMPLOYEES_LIST,
	B2B_VIEW_COMPANY_LIST,
	hasPermission,
	SUPER_ADMIN,
	B2B_SENSITIVE_COMPANY_DETAILS,
} from '@/middlewares/permissions';

export default {
	path: '/company',
	component: Content,
	meta: {
		middleware: [isAuth, (nav) => hasPermission(nav, [B2B_VIEW_COMPANY_DETAILS], [SUPER_ADMIN])],
	},
	children: [
		{
			path: '/company',
			redirect: { name: Names.CompanyDetails },
		},
		{
			path: 'list',
			name: Names.CompaniesList,
			component: () => import('@/views/company/CompaniesList'),
			meta: {
				title: 'Companies List',
				middleware: [isAuth, (nav) => hasPermission(nav, [B2B_VIEW_COMPANY_LIST], [SUPER_ADMIN])],
			},
		},
		{
			path: 'details',
			name: Names.CompanyDetails,
			component: () => import('@/views/company/CompanyDetails'),
			meta: {
				title: 'Company Details',
				middleware: [isAuth, (nav) => hasPermission(nav, [B2B_SENSITIVE_COMPANY_DETAILS], [SUPER_ADMIN])],
			},
			children: [
				{
					path: ':id',
					name: Names.CompanyDetails,
					component: () => import('@/views/company/CompanyDetails'),
					meta: {
						title: 'Company Details',
						middleware: [
							isAuth,
							(nav) => hasPermission(nav, [B2B_SENSITIVE_COMPANY_DETAILS], [SUPER_ADMIN]),
						],
					},
				},
			],
		},
		{
			path: 'employees',
			name: Names.EmployeeList,
			component: () => import('../views/company/EmployeeList'),
			meta: {
				title: 'Employee List',
				middleware: [isAuth, (nav) => hasPermission(nav, [B2B_VIEW_COMPANY_EMPLOYEES_LIST], [SUPER_ADMIN])],
			},
		},
		{
			path: 'dashboard',
			name: Names.B2B_Dashboard,
			component: () => import('@/views/company/Dashboard'),
			meta: {
				title: 'Dashboard',
				middleware: [isAuth, (nav) => hasPermission(nav, [B2B_VIEW_COMPANY_DETAILS], [SUPER_ADMIN])],
			},
		},
		{
			path: 'finance-overview',
			name: Names.B2B_Finance,
			component: () => import('@/views/company/finance/Finance.vue'),
			meta: {
				title: 'Finance',
				middleware: [isAuth, (nav) => hasPermission(nav, [ACCOUNT_RECORDS], [SUPER_ADMIN])],
			},
		},
		{
			path: 'account-records',
			name: Names.B2B_FinanceSituation,
			component: () => import('@/views/company/finance/Situation.vue'),
			meta: {
				title: 'Account Records',
				middleware: [isAuth, (nav) => hasPermission(nav, [ACCOUNT_RECORDS], [SUPER_ADMIN])],
			},
		},
		{
			path: 'budgets',
			name: Names.CompanyBudgets,
			component: () => import('../views/company/Budgets'),
			meta: {
				title: 'Company Budgets',
				middleware: [isAuth, (nav) => hasPermission(nav, [B2B_COMPANY_BUDGET], [SUPER_ADMIN])],
			},
		},
		{
			path: ':companyId/budgets/:id',
			name: Names.CompanyBudgetDetails,
			component: () => import('../views/company/BudgetDetails'),
			meta: {
				title: 'Budget Details',
				middleware: [isAuth, (nav) => hasPermission(nav, [B2B_COMPANY_BUDGET], [SUPER_ADMIN])],
			},
		},
	],
};
